import * as angular from 'angular';
import ExternalPluginView from './ExternalPluginView.html';
import { ExternalPluginController } from './ExternalPluginController';
export const externalPluginStateName = 'auth.application.detail.plugin';
export const externalPlugin = angular
    .module('application.plugin', ['ui.router'])
    .controller('ExternalPluginController', ExternalPluginController)
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state(externalPluginStateName, {
            url: '/plugin/:pluginId',
            views: {
                'content@auth.application.detail': {
                    template: ExternalPluginView,
                    controller: ExternalPluginController,
                    controllerAs: '$ctrl',
                },
            },
            params: {
                pluginId: '',
            },
        });
    }])
    .name;
